import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'wba-button-leiste',
    templateUrl: './button-leiste.component.html',
    standalone: false
})
export class ButtonLeisteComponent {

  @Input() btnLeftLabel = 'Zurück';
  @Input() btnLeftIconClass = 'ba-btn-icon ba-icon-chevron-left-before';
  @Input() btnLeftClass = 'ba-btn ba-btn-contrast';
  @Input() btnLeftDisabled = false;
  @Input() btnLeftHidden = false;
  @Input() btnLeftId = '';
  @Input() dataAnalyticsNameLeft = '';

  @Input() btnRightLabel = 'Weiter';
  @Input() btnRightIconClass = 'ba-btn-icon ba-icon-chevron-right-after';
  @Input() btnRightClass = 'ba-btn ba-btn-primary';
  @Input() btnRightDisabled = false;
  @Input() btnRightHidden = false;
  @Input() btnRightId = '';
  @Input() dataAnalyticsNameRight = '';

  @Output() clickLeft: EventEmitter<null> = new EventEmitter();
  @Output() clickRight: EventEmitter<null> = new EventEmitter();

  clickLeftEvent() {
    this.clickLeft.emit();
  }

  clickRightEvent() {
    this.clickRight.emit();
  }
}
